
const config = {
    frontend: {
        app_url: process.env.APP_URL,
    },
    backend: {
        api_base_url: process.env.API_URL,
    },
};

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js